import { useSelector } from 'react-redux';
import SectionPreview from '../laptop/SectionPreview/SectionPreview';
import SectionPreviewMobile from '../mobile/SectionPreview/SectionPreview';
import classes from './Home.module.css';
import isMobileViewHook from '../../hooks/isMobileView';

const Home = () => {
  const isMobileView = isMobileViewHook();
  const hub = useSelector((state) => state.hub.hub);

  if (!hub) return null;
  const { sections } = hub;
  const sectionsWithoutHome = sections.filter(
    (sec) => sec.name !== 'Home' && sec.name !== 'Builder Coupon'
  );
  return (
    <div className={classes.home}>
      {sectionsWithoutHome.map(
        (
          {
            color,
            name,
            link,
            buttonLabel,
            previewImage,
            previewImageMobile,
            defaultSubsection,
          },
          i
        ) =>
          isMobileView ? (
            <SectionPreviewMobile
              key={name}
              name={name}
              link={link}
              buttonLabel={buttonLabel}
              color={color}
              imageSrc={previewImageMobile[0].url}
              defaultSubsection={defaultSubsection}
              index={i + 1}
            />
          ) : (
            <SectionPreview
              key={name}
              name={name}
              link={link}
              buttonLabel={buttonLabel}
              color={color}
              imageSrc={previewImage[0].url}
              defaultSubsection={defaultSubsection}
              index={i + 1}
            />
          )
      )}
    </div>
  );
};
export default Home;
